import { render, staticRenderFns } from "./gagc.vue?vue&type=template&id=a79a4b68&scoped=true"
import script from "./gagc.vue?vue&type=script&lang=js"
export * from "./gagc.vue?vue&type=script&lang=js"
import style0 from "@/assets/iconFonts/iconfont.css?vue&type=style&index=0&id=a79a4b68&prod&scoped=true&lang=css&external"
import style1 from "./gagc.vue?vue&type=style&index=1&id=a79a4b68&prod&scoped=true&lang=css"
import style2 from "./gagc.vue?vue&type=style&index=2&id=a79a4b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79a4b68",
  null
  
)

export default component.exports